import styled from 'styled-components';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const MapCruiseCardShipBase = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.secondary.main};

  ${({ theme }) => ({
    [BrandCode.RoyalCaribbean]: `
      gap: 5px;

      svg {
        width: 24px;
        height: 24px;

        path {
          fill: ${theme.palette.secondary.main};
        }
      }

      ${MapCruiseCardShipLabel} {
        display: none;
      }
    `,
    [BrandCode.Celebrity]: `
      gap: 10px;

      svg {
        display: none;
      }
    `,
  })[theme.brandCode]};
`;

export const MapCruiseCardShipLabel = styled.h3`
  font-size: 16px;
  font-style: normal;
  line-height: normal;

  ${({ theme }) => ({
    [BrandCode.RoyalCaribbean]: `
      display: none;
    `,
  })[theme.brandCode]};
`;

export const MapCruiseCardShipName = styled.h3`
  font-family: ${({theme}) => theme.typography.fontFamilySemiBold};
  font-size: 16px;

  ${({ theme }) => ({
    [BrandCode.RoyalCaribbean]: `
      line-height: 24px;
      letter-spacing: -0.32px;

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        font-size: 18px;
        letter-spacing: -0.36px;
      }
    `,
    [BrandCode.Celebrity]: `
      line-height: normal;
      letter-spacing: 0.32px;
      text-transform: uppercase;
    `,
  })[theme.brandCode]};
`;